import { useLang } from "@/lib/i18n";
import { Reveal } from "@/components/Reveal";

const ROWS = [
  ["XS", "80 – 84", "60 – 64", "86 – 90"],
  ["S", "84 – 88", "64 – 68", "90 – 94"],
  ["M", "88 – 92", "68 – 72", "94 – 98"],
  ["L", "92 – 96", "72 – 78", "98 – 102"],
  ["XL", "96 – 102", "78 – 84", "102 – 108"],
];

export default function SizeGuide() {
  const { t } = useLang();
  return (
    <div className="py-14 lg:py-20 pb-24" data-testid="size-guide-page">
      <div className="max-w-[900px] mx-auto px-5 lg:px-10">
        <Reveal>
          <p className="eyebrow mb-3">MIORA</p>
          <h1 className="font-serif font-light text-5xl lg:text-6xl text-ink">{t.size.title}</h1>
          <p className="mt-4 text-ink/60 text-sm">{t.size.sub}</p>
        </Reveal>

        <Reveal className="mt-12 overflow-x-auto">
          <table className="w-full text-sm border-collapse" data-testid="size-table">
            <thead>
              <tr className="border-b border-ink/20 text-start">
                <th className="py-4 px-4 text-start text-[11px] uppercase tracking-[0.14em] text-ink/50 font-medium">{t.size.colSize}</th>
                <th className="py-4 px-4 text-start text-[11px] uppercase tracking-[0.14em] text-ink/50 font-medium">{t.size.colBust}</th>
                <th className="py-4 px-4 text-start text-[11px] uppercase tracking-[0.14em] text-ink/50 font-medium">{t.size.colWaist}</th>
                <th className="py-4 px-4 text-start text-[11px] uppercase tracking-[0.14em] text-ink/50 font-medium">{t.size.colHip}</th>
              </tr>
            </thead>
            <tbody>
              {ROWS.map((r, i) => (
                <tr key={i} className="border-b border-ink/10 hover:bg-cream/60 transition-colors" data-testid={`size-row-${r[0].toLowerCase()}`}>
                  <td className="py-4 px-4 font-serif text-lg text-ink">{r[0]}</td>
                  <td className="py-4 px-4 text-ink/75">{r[1]}</td>
                  <td className="py-4 px-4 text-ink/75">{r[2]}</td>
                  <td className="py-4 px-4 text-ink/75">{r[3]}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <p className="mt-3 text-[11.5px] text-ink/45">{t.size.fitNote}</p>
        </Reveal>

        <Reveal className="mt-16 grid md:grid-cols-2 gap-10 items-start">
          <div>
            <h2 className="font-serif font-light text-2xl lg:text-3xl text-ink mb-6">{t.size.howTitle}</h2>
            <ol className="space-y-4">
              {[t.size.how1, t.size.how2, t.size.how3].map((s, i) => (
                <li key={i} className="flex gap-4 text-sm text-ink/70 leading-relaxed">
                  <span className="w-7 h-7 shrink-0 rounded-full bg-rose/15 text-rose-deep flex items-center justify-center text-[12px] font-serif">{i + 1}</span>
                  {s}
                </li>
              ))}
            </ol>
          </div>
          <div className="bg-cream border border-ink/10 rounded-sm p-7" data-testid="size-note-card">
            <h3 className="font-serif text-xl text-ink mb-3">{t.size.noteTitle}</h3>
            <p className="text-sm text-ink/70 leading-relaxed">{t.size.note}</p>
          </div>
        </Reveal>
      </div>
    </div>
  );
}
